import styled from "styled-components";
import { bodyColor } from "../../../../../config/constants";

// Styles
export const SessionDiv = styled.div`
  margin: 5px auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: #fff;
  @media (max-width: 910px) {
    width: 85%;
    height: auto;
    flex-direction: column;
    align-items: flex-end;
    background-color: transparent;
    box-shadow: none;
    transition: all 0.5s ease-out;
  }
`;
export const SessionInfoDiv = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const ProtocolCardDiv = styled.div`
  width: 330px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  @media (max-width: 910px) {
    width: 100%;
    position: relative;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-out;
  }
`;
export const ProtocolImgDiv = styled.div`
  margin-right: 15px;
  width: 80px;
  height: 40px;
`;
export const ProtocolImg = styled.img`
  width: 80px;
  height: 40px;
`;
export const ProtocolName = styled.p`
  margin-left: 15px;
  font-size: 14px;
  color: #000;
  font-weight: 600;
  text-align: left;
`;
export const TimeDataDiv = styled.div`
  width: 150px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const TimeDataText = styled.p`
  font-size: 14px;
  color: #000;
  text-align: center;
`;
export const SessionDetailsDiv = styled.div`
  width: 80px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: right;
`;
export const SessionDetailsButton = styled.button`
  width: 33px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  outline: none;
  border-left: 2px solid ${bodyColor};
  cursor: pointer;
`;
export const ArrowImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const HitsAndErrorsDiv = styled.div`
  padding: 0 2px 2px;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const HitsAndErrorsRow = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
`;
export const HitsAndErrorsBox = styled.div`
  padding-left: 16px;
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  box-shadow: ${({ topShadow }) => topShadow && "inset 0 5px 10px -7px rgb(0 0 0 / 10%)"};
  background-color: ${({ background }) => background && background};
  border-left: ${({ borderLeft }) => borderLeft && borderLeft};
  border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};
`;
export const HitsAndErrorsText = styled.p`
  font-size: 14px;
  font-weight: ${({ strong }) => (strong ? "600" : "400")};
`;
